import { get } from '@client/lib/request';

export function updateGeneratedUrl(initialData) {
    const search = initialData.generatedUrl && initialData.generatedUrl.split('?').length === 2 ? `?${initialData.generatedUrl.split('?')[1]}` : '';

    return `${window.location.pathname}${search}`;
}

export function loadTrackData() {
    return get(`/mylounge-api/data-layer${window.location.search}`)
        .then(data => {
            const initialData = data.data || {};
            initialData.generatedUrl = updateGeneratedUrl(initialData);

            return initialData;
        })
        .catch(() => ({}));
}
